<template>
    <main-layout>
        <template #header>
            <main-header :title="'Agent 배포'">
            </main-header>
        </template>

        <template #toolbar>
        </template>

        <template #body>
            <div style="flex-grow: 0;">
                <v-tabs
                        v-model="tab"
                        background-color="primary"
                        dark
                >
                    <v-tab
                            v-for="item in tabs"
                            :key="item.key"
                    >
                        {{ item.text }}
                    </v-tab>
                </v-tabs>
            </div>

            <div style="flex-grow: 1;">
                <v-tabs-items v-model="tab" class="fill-height">
                    <v-tab-item
                            class="fill-height"
                            v-for="item in tabs"
                            :key="item.key"
                    >
                        <component :is="item.component"></component>
                    </v-tab-item>
                </v-tabs-items>
            </div>
        </template>
    </main-layout>
</template>

<script>
    import MainHeader from "@/components/common/layout/MainHeader";
    import MainLayout from "@/components/common/layout/MainLayout";
    import MainToolbar from "@/components/common/layout/MainToolbar";
    import MainBody from "@/components/common/layout/MainBody";
    import MonitoringAgentDeployByCountry from "@/views/monitoring/version-deploy/MonitoringAgentDeployByCountry";
    import MonitoringAgentDeployByRentalcompany
        from "@/views/monitoring/version-deploy/MonitoringAgentDeployByRentalcompany";

    const SORT = {
        BY_COUNTRY: "BY_COUNTRY",
        BY_RENTALCOMPANY: "BY_RENTALCOMPANY",
    };

    export default {
        name: "MonitoringAgentDeploy",
        components: {MainBody, MainToolbar, MainLayout, MainHeader},
        data() {
            return {
                tab: SORT.BY_COUNTRY,
                tabs: [
                    {
                        key: SORT.BY_COUNTRY,
                        text: "국가별",
                        component: MonitoringAgentDeployByCountry,
                    },
                    {
                        key: SORT.BY_RENTALCOMPANY,
                        text: "사업자별",
                        component: MonitoringAgentDeployByRentalcompany,
                    },
                ]
            };
        },
    }
</script>

<style scoped>

</style>